var getNative = require('./getNative');

/** Native method references. */
var WeakMap = getNative(global, 'WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/metaMap.js
 ** module id = 392
 ** module chunks = 0 1
 **/